
import { ADD_USER_STEP_FIELDS } from "../../utils/addUserStepFields";
export const StepIndicator = ({
  currentStep,
  totalSteps,
  setCurrentStep,
  trigger,
  completedSteps,
  setCompletedSteps
}) => {
  const handleStepClick = async (step) => {
    // Clicking current step - do nothing
    if (step === currentStep) {
      return;
    }

    // Allow going backward to any previous step
    if (step < currentStep) {
      setCurrentStep(step);
      return;
    }

    // Validate current step before moving forward
    const fieldsToValidate =
      ADD_USER_STEP_FIELDS[currentStep]?.fields || [];

    const isValid = await trigger(fieldsToValidate);

    if (!isValid) {
      return;
    }

    // Mark current step as completed
    setCompletedSteps((prev) => [
      ...new Set([...prev, currentStep]),
    ]);

    // Move to next step
    setCurrentStep(step);
  };

  return (
    <div className="flex justify-center md:py-5">
      {totalSteps.map((step, index) => {
        const isCurrent = currentStep === step;
        const isCompleted = completedSteps.includes(step);
        let bgColor = "bg-gray-300 text-black"; // default
        let lineColor = "bg-gray-300"; // default

        if (isCompleted) {
          bgColor = "bg-green-3 text-white";
          lineColor = "bg-green-3";
        }

        if (isCurrent) {
          bgColor = "bg-dark-blue text-white";
          lineColor = "bg-dark-blue";
        }

        return (
          <div className="flex items-center" key={step}>
            <div
              className={`py-1 px-3 rounded-md transition-all duration-200 ${bgColor} relative cursor-pointer`}
              onClick={()=>handleStepClick(step)}
            >
              <p>{step}</p>
            </div>
            {index < totalSteps.length - 1 && (
              <div
                className={`h-1 w-8 sm:w-20 transition-all duration-200 ${lineColor}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
